import { ChangeDetectionStrategy, Component, Input, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'accordion-item',
  template: `
  <div class="accordion-item" [class.disabled]="disabled">
    <div class="accordion-item__header accordion-header" (click)="toggle.emit()">
      <span class="accordion-header__icon icon {{icon}}"></span><span>{{title}}</span>
      <span class="accordion-header__arrow icon icon-next" [ngClass]="{'accordion-header__arrow--opened': opened}"></span>
    </div>
    <div class="accordion-item__content" [@expandCollapse]="opened ? 'open' : 'close'">
      <div class="accordion-item__container">
        <ng-content></ng-content>
      </div>
    </div>
  <div>
  `,
  animations: [
    trigger('expandCollapse', [
      state('open', style({
        'height': '*'
      })),
      state('close', style({
        'height': '0px'
      })),
      transition('open <=> close', animate(300))
    ])
  ],
  host: {
    class: 'accordion__item'
  }
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccordionItemComponent {

  @Input() opened = false;

  @Input() disabled: boolean;
  @Input() title: string;
  @Input() icon: string;

  @Output() toggle: EventEmitter<any> = new EventEmitter<any>();
}
